import { WSList, WSSectionToolbar } from "@wingspanhq/fe-component-library";
import React from "react";

import { FilterableTablePayrollsEmployee } from "../../components/TablePayrollsEmployee/FilterableTablePayrollsEmployee";
import {
  PayrollRunsYear,
  routeHelperPayrollRunsDashboardHistory,
  routeHelperPayrollRunsDetails
} from "../../paths";

export const RoutePayrollRunsHistory: React.FC = () => {
  const goToDetails = routeHelperPayrollRunsDetails.useGoTo();
  const {
    params: { year: yearParam }
  } = routeHelperPayrollRunsDashboardHistory.useData();
  const year = yearParam as PayrollRunsYear;

  return (
    <WSList gap="S" mt="L">
      <WSSectionToolbar title="Payroll history" />
      <FilterableTablePayrollsEmployee
        year={year}
        onRowOpen={payrollRunId => goToDetails({ year, payrollRunId })}
      />
    </WSList>
  );
};
